
import * as actions from 'actions';
import emojisMaker from 'reducersMakers/emojisMaker';

export default emojisMaker({
  showType: actions.FEEDBACK_EMOJIS_SHOW,
  closeType: actions.FEEDBACK_EMOJIS_HIDE
});



/** WEBPACK FOOTER **
 ** ./src/members/state/feedback/emojis/reducer.js
 **/